import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Dialog } from '@material-ui/core';

import { ErrorDialogPropTypes } from './prop-types';
import DialogBody from './body';
import styles from './error-dialog.styles';

// Separate body to use native lazy loading
const ErrorDialog = ({ open, classes, onClose, ...props }) => (
  <Dialog open={open} onClose={onClose} classes={{ paper: classes.dialog }}>
    <DialogBody {...props} onClose={onClose} />
  </Dialog>
);

ErrorDialog.propTypes = ErrorDialogPropTypes;

export default withStyles(styles)(ErrorDialog);
